import { Address, PublicClient } from 'viem';

import { getLiquidStakingTokenContract } from 'modules/api/contracts/getLiquidStakingTokenContract';
import { memoizePromise } from 'modules/api/methods/memoizePromise';

export async function _getLiquidStakingPoolAddress(
  client: PublicClient,
): Promise<Address> {
  const contract = getLiquidStakingTokenContract(client);

  return contract.read.stakingPool();
}

export const getLiquidStakingPoolAddress = memoizePromise(
  _getLiquidStakingPoolAddress,
  provider => {
    return `${provider.chain?.id || 'unknown'}`;
  },
);
